<template>
  <div>
    <div :class="`card br-10 ${winner.can_predict?'relative z-20':'mb-6'}`">
      <div class="w-full bg-white  px-2 br-t-10">
        <span v-if="winner.match_remaining_time" class="text-xxs font-normal rounded-sm px-1 text-opacity-50 text-black">Starts in</span><span v-if="winner.match_remaining_time" class="text-xxs font-medium text-black">{{winner.match_remaining_time}}</span>
        <span v-if="winner.match_closing_time" class="text-xxs font-normal rounded-sm px-1 text-opacity-50 text-black">Closes in</span><span v-if="winner.match_closing_time" class="text-xxs font-medium text-black">{{winner.match_closing_time}}</span>
      </div>
      <div class="w-full flex justify-between items-center">
        <div class="w-1/3 predict-background">
        </div>
        <div class="w-2/3 flex items-center">
          <span class="block font-extrabold leading-none tracking-tight trophy-winner">Can you guess the trophy winners?</span>
        </div>
      </div>
    </div>
    <router-link v-if="winner.can_predict" :to="`/winner/${winner.id}`" class="btn-login font-bold text-white w-full -mt-4 p-4  relative z-10 pt-7 block text-center mb-6">Predict Winners</router-link>
  </div>
</template>
<script type="text/javascript">
  export default {
    props: {
      winner: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    methods:{
      loadDefaultUrl(event){
        event.target.src = require(`@/assets/ipl-team.jpg`);
      }
    }
  }
</script>
<style type="text/css" scoped>
  .card {
    background: linear-gradient(180deg, #F5F5F5 0%, #F0F0F0 100%);
  }
  .btn-login {
    background: linear-gradient(180deg, #FF9C59 0%, #ED6C15 100%);
    box-shadow: inset 0px -4px 0px rgba(0, 0, 0, 0.16);
    border-radius: 10px;
  }

  .btn-login:active{
    background: linear-gradient(180deg, #FF9C5999 0%, #ED6C1599 100%);
    outline: none;
  }
  .br-t-10 {
    border-radius: 10px 10px 0 0;
  }
  .br-tl-10{
    border-radius: 10px 0 0 0; 
  }
  .trophy-winner{
    @apply px-4 text-3xl;
    background: linear-gradient(180deg, #F07E22 0%, #FFBF8C 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    mix-blend-mode: multiply;
  }
  .predict-background{
    background: no-repeat center/cover url('~@/assets/predict.png');
    mix-blend-mode: darken;
    border-radius: 10px 0px 0px 10px;
    height: 129px;
  }
  @media (max-width: 421px) {
    .trophy-winner{
      font-size: 1.65rem;
      line-height: 2.25rem;
    }
   }
   @media (max-width: 397px) {
    .trophy-winner{
      @apply px-2;
      font-size: 1.65rem;
      line-height: 2.25rem;
    }
   }
   @media (max-width: 370px) {
    .trophy-winner{
      @apply px-2;
      font-size: 1.6rem;
      line-height: 2rem;
    }
   }
   @media (max-width: 362px) {
    .predict-background{
      height: 115px;
    }
   }

   @media (max-width: 330px) {
    .trophy-winner{
      font-size: 1.4rem;
      line-height: 1.5rem;
    }
    .predict-background{
      height: 108px;
    }
   }
</style>